import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;

  .subHeader {
    display: flex;
    gap: 1rem;
    align-items: center;

    h1 {
      color: ${({ theme }) => theme.colors.secondary};
      font-size: 1.3rem;
      margin: 0;
      font-weight: 500;
    }
  }
  .close-div {
    padding: 0;
    height: 20px;

    button {
      color: #fff;
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      width: 20px;
      height: 19px;
      border-radius: 100%;
      padding: 0;
      border: none;

      :hover {
        cursor: pointer;
      }
    }
  }
`;

export const Container = styled.div`
  width: 100%;
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: end;
  p {
    display: flex;
    align-items: center;
    align-self: start;
    gap: 0.5rem;
  }
  gap: 2rem;
`;
